// extracted by mini-css-extract-plugin
export default {"list":"qTMkBEI58t_YpOsgKq77","item":"L3K18nAY6pDx5sBZJd_N","icon":"tlX2591AuCi95Z027z2q"};